import React, { useEffect, useState } from "react";
import { Box, Stack, TextField } from "@mui/material";
import { useIntl } from "react-intl";
import RevaText from "components/common/RevaText";
import { isValidHexColor, normalizeHexColor } from "./branding-helpers";

const BrandingColorPicker = ({ labelId, value, onChange, disabled = false, compact = false }) => {
  const intl = useIntl();
  const normalized = normalizeHexColor(value, "#262626");
  const [draft, setDraft] = useState(value || "");

  useEffect(() => {
    // Keep the draft when it is the valid color that was just committed (e.g. "#abc" -> "#AABBCC"),
    // so the user can keep typing; otherwise follow the value from the form.
    setDraft((current) => (isValidHexColor(current) && normalizeHexColor(current) === value ? current : value || ""));
  }, [value]);

  const draftInvalid = draft !== (value || "") && !isValidHexColor(draft);

  return (
    <Stack
      direction={compact ? "column" : { xs: "column", sm: "row" }}
      spacing={1}
      alignItems={compact ? "stretch" : { sm: "center" }}
      sx={{ mb: compact ? 1.5 : 2 }}
    >
      <RevaText variant="body2" sx={{ minWidth: compact ? undefined : { sm: 240 }, flexShrink: 0, fontSize: compact ? 12 : undefined }}>
        {intl.formatMessage({ id: labelId })}
      </RevaText>
      <Stack direction="row" spacing={1} alignItems="center">
        <Box
        component="input"
        type="color"
        value={normalized}
        disabled={disabled}
        onChange={(event) => onChange(normalizeHexColor(event.target.value, normalized))}
        sx={{
          width: 48,
          height: 36,
          p: 0,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
          cursor: disabled ? "not-allowed" : "pointer",
          bgcolor: "background.paper",
        }}
      />
      <TextField
        size="small"
        value={draft}
        disabled={disabled}
        error={draftInvalid}
        helperText={draftInvalid ? intl.formatMessage({ id: "gestion.branding.colors.invalid" }) : undefined}
        onChange={(event) => {
          const next = event.target.value;
          setDraft(next);
          if (isValidHexColor(next)) onChange(normalizeHexColor(next, normalized));
        }}
        onBlur={() => setDraft(isValidHexColor(draft) ? normalizeHexColor(draft, normalized) : value || "")}
        sx={{ width: compact ? 100 : 120 }}
        inputProps={{ spellCheck: false }}
      />
      </Stack>
    </Stack>
  );
};

export default BrandingColorPicker;
